var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtArrowsCarouselLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1 120.5L.6 60 65.1-.5l2.8 3L6.4 60l61.5 57.5z"
  })));
}
export default SvgFtArrowsCarouselLeft;